// extracted by mini-css-extract-plugin
export default {"gameScreen":"Game_gameScreen__domaR"};